<template>
  <div class="settings">

    <!-- <div class="container-header">
      <div class="container-header__title">{{ i18n.set_header() }}</div>
    </div> -->

    <div class="settings__item">
      <div class="settings__item-header text_large" v-if="config.FEATURE_FLAGS.verification">
        {{ i18n.set_account() }}
      </div>

      <div class="container container_30" v-if="config.FEATURE_FLAGS.verification">
        <md-list>
          <md-list-item to="/verification">
            <span class="settings__item-text text_large">{{ i18n.set_verify_account() }}</span>
            <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>
          </md-list-item>
        </md-list>
      </div>
    </div>

    <div class="settings__item">
      <div class="settings__item-header text_large">{{ i18n.set_security() }}</div>

      <div class="container container_30">
        <md-list>
          <change-password class="security-settings__change-password"/>
          <md-divider class="md-dense" v-if="tfaEnable"/>
          <tfa-settings class="security-settings__tfa-settings"
                        :tfa-recovery-init="$route.params.tfaRecovery"
                        v-if="tfaEnable"
          />
        </md-list>
      </div>
    </div>

    <div class="settings__item">
      <div class="settings__item-header text_large">{{ i18n.set_keys() }}</div>

      <div class="container container_30">
        <md-list>
          <account-id class="security-settings__account-id"/>
          <md-divider class="md-dense"/>
          <seed class="security-settings__seed"/>
        </md-list>
      </div>
    </div>

    <div class="settings__item"
      v-if="config.FEATURE_FLAGS.tokens
        && !config.FEATURE_FLAGS.tokensItemInMenu
        && (accountVerified || isSystemAccount)
      "
    >
      <div class="settings__item-header text_large">
        {{ i18n.lbl_tokens_management() }}
      </div>

      <div class="container container_30">
        <md-list>
          <md-list-item to="/tokens">
            <span class="settings__item-text text_large">
              {{ i18n.lbl_explore_tokens() }}
            </span>
            <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>
          </md-list-item>
        </md-list>
      </div>
    </div>

    <md-button type="submit" @click="toggleSignOut" class="btn btn_big md-primary">
      {{ i18n.set_logout() }}
      <md-icon md-src="/static/img/exit_app.svg"/>
    </md-button>

    <md-dialog :md-active.sync="view.mode">
      <md-icon class="settings__logout-icon md-size-2x" md-src="/static/img/log_out_app.svg"/>
      <div class="text_large">{{ i18n.set_dialog_title() }}</div>
      <div class="settings__logout-text text_medium">{{ i18n.set_dialog_content() }}</div>
      <div class="btn-wrap space-between margin-top">
        <md-button class="btn md-primary" @click="signOut">{{ i18n.set_bt_confirm() }}</md-button>
        <md-button class="btn md-primary" @click="toggleSignOut">{{ i18n.set_bt_cancel() }}</md-button>
      </div>
    </md-dialog>
  </div>
</template>

<script>
  import config from '@conf'
  import ChangePassword from './Security.ChangePassword'
  import TfaSettings from './Security.TfaSettings'
  import AccountId from './Security.AccountId'
  import Seed from './Security.Seed'
  import ChangeTaid from './Security.Taid'
  import ChangeXpay from './Security.Xpay'

  import { i18n } from '@js/i18n'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import {factorsService} from '@api/factors.service'

  export default {
    name: 'settings-security',
    components: {
      ChangeTaid,
      ChangePassword,
      ChangeXpay,
      TfaSettings,
      AccountId,
      Seed
    },
    data: _ => ({
      i18n,
      config,
      tfaEnable: false,
      view: {
        mode: false
      }
    }),
    computed: {
      ...mapGetters([
        vuexTypes.accountSignerName,
        vuexTypes.accountBlocked,
        vuexTypes.isSystemAccount,
        vuexTypes.accountVerified
      ]),
      operational () {
        let name = this.accountSignerName
        if (name) {
          name = name.toLowerCase()
          return name.startsWith('commission') || name.startsWith('operation') || name.startsWith('cashbox')
        }
        return false
      }
    },
    async created () {
      await this.loadAccount()

      const data = (await factorsService.checkTFAEnabled()).data()
      this.tfaEnable = data.tfa_enabled
    },
    methods: {
      ...mapActions({
        loadAccount: vuexTypes.GET_ACCOUNT_DETAILS,
        logOut: vuexTypes.LOG_OUT
      }),
      toggleSignOut () {
        this.view.mode = !this.view.mode
      },
      signOut () {
        this.logOut()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './settings.scss';
  .settings {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Settings.Security.vue